import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { BREAKPOINTS } from '@hookdeck/theme';
const checkBreakpoint = (): keyof typeof BREAKPOINTS => {
  for (const [key, value] of Object.entries(BREAKPOINTS).reverse()) {
    if (!value) {
      return key as keyof typeof BREAKPOINTS;
    }
    const query = `(min-width: ${value}px)`;
    const media = window.matchMedia(query);
    if (media.matches) {
      return key as keyof typeof BREAKPOINTS;
    }
  }
  // This should never happen
  return 'desktop';
};
const useViewportBreakpoint = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = checkBreakpoint();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [matches, setMatches] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const listener = () => {
        const match = checkBreakpoint();
        setMatches(match);
      };
      window.addEventListener("resize", listener);
      checkBreakpoint();
      window.addEventListener("resize", checkBreakpoint);
      return _temp;
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return matches;
};
export default useViewportBreakpoint;
function _temp() {
  return window.removeEventListener("resize", checkBreakpoint);
}